import { render, staticRenderFns } from "./titlebar.vue?vue&type=template&id=0ee34b23"
import script from "./titlebar.vue?vue&type=script&lang=js"
export * from "./titlebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports